import React from 'react';
import './ConcurrentSessionPopup.css';

const ConcurrentSessionPopup = ({ onContinue, onCancel }) => {
  return (
    <div className="concurrent-session-overlay">
      <div className="concurrent-session-popup">
        <h3>Active Session Detected</h3>
        <p>You are already logged in from another browser or device.</p>
        <p>Do you want to continue with this session? Your previous session will be terminated.</p>
        <div className="popup-actions">
          <button className="btn-continue" onClick={onContinue}>
            Continue Here
          </button>
          <button className="btn-cancel" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConcurrentSessionPopup;
